var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 406.72 484.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}.cls-2{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.06,125.83a22.83,22.83,0,0,0-6.52-16L272.35,17.09a22.15,22.15,0,0,0-15.83-6.63h-5.68V131.61H370.06Z",
    transform: "translate(-12.39 -10.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.43,386.84a110.48,110.48,0,0,1,.76-12.94H113a11.3,11.3,0,0,1-11.17-11.36V355A11.3,11.3,0,0,1,113,343.61H221.2a109.15,109.15,0,0,1,19.28-30.28H113A11.31,11.31,0,0,1,101.81,302V294.4A11.3,11.3,0,0,1,113,283H269.47c9,0,9,1.07,9,1.07a106,106,0,0,1,91.55.85V161.89H243.38A22.6,22.6,0,0,1,221,139.18V10.46H34.74A22.48,22.48,0,0,0,12.39,33.18V472.33A22.47,22.47,0,0,0,34.74,495H306.4C253.42,488.37,212.43,442.48,212.43,386.84Zm-110.62-153A11.3,11.3,0,0,1,113,222.47H269.47a11.3,11.3,0,0,1,11.17,11.35v7.58a11.3,11.3,0,0,1-11.17,11.35H113a11.3,11.3,0,0,1-11.17-11.35Z",
    transform: "translate(-12.39 -10.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323,289.83c53.07,0,96.07,43.69,96.07,97.62s-43,97.62-96.07,97.62S227,441.38,227,387.45,270,289.83,323,289.83Zm-11.2,56.52,29.25,28.5H270.35a9.35,9.35,0,0,0-9.3,9.45v6.3a9.35,9.35,0,0,0,9.3,9.44h70.74l-29.25,28.5a9.56,9.56,0,0,0-.16,13.5l4.27,4.3a9.15,9.15,0,0,0,13.13,0l51.41-52.2a9.53,9.53,0,0,0,0-13.35l-51.41-52.27a9.15,9.15,0,0,0-13.13,0l-4.27,4.29A9.61,9.61,0,0,0,311.84,346.35Z",
    transform: "translate(-12.39 -10.46)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFileIcon);
export default __webpack_public_path__ + "static/media/view-file-icon.29f2cb1b2a8cca4542de62de48b9d4c4.svg";
export { ForwardRef as ReactComponent };